import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ArticleInfos } from "../../models/article.model";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { environment } from "environments/environment";
import { safeFirstValueFrom } from "../../../../shared/utils/safe-first-value-from";

@Injectable({ providedIn: "root" })
export class ArticlesInfosApiService implements EntityApiService<ArticleInfos> {
  loadOne(id: string): Observable<ArticleInfos> {
    throw new Error("Method not implemented.");
  }

  httpClient = inject(HttpClient);

  create(entity: ArticleInfos): Observable<ArticleInfos> {
    throw new Error("Method not implemented.");
  }

  remove(id: string): Observable<string> {
    throw new Error("Method not implemented.");
  }

  update(entity: ArticleInfos): Observable<ArticleInfos> {
    return this.httpClient.post<ArticleInfos>(
      `${environment.api()}/specification_etape/infosArticle`,
      entity,
    );
  }

  loadAll(): Observable<ArticleInfos[]> {
    return this.httpClient.get<ArticleInfos[]>(
      `${environment.api()}/specification_etape/infosArticle`,
    );
  }

  async getEan13Dispo() {
    return await safeFirstValueFrom(
      this.httpClient.post<{ ean13: string }>(
        `${environment.api()}/infosArticle/ask_ean13`,
        {},
      ),
    );
  }

  loadByEan13(ean13: string): Observable<ArticleInfos[]> {
    return this.httpClient.get<ArticleInfos[]>(
      `${environment.api()}/specification_etape/infosArticle/ean13/${ean13}`,
    );
  }

  loadByEan14(ean14: string): Observable<ArticleInfos[]> {
    return this.httpClient.get<ArticleInfos[]>(
      `${environment.api()}/specification_etape/infosArticle/ean14/${ean14}`,
    );
  }

  loadByCode(code: string): Observable<ArticleInfos[]> {
    const safeCode = encodeURIComponent(code); // très important: encodeURIComponent
    return this.httpClient.get<ArticleInfos[]>(
      `${environment.api()}/specification_etape/infosArticle/code/${safeCode}`,
    );
  }

  loadByArticleId(articleId: string): Observable<ArticleInfos> {
    return this.httpClient.get<ArticleInfos>(
      `${environment.api()}/specification_etape/infosArticle/articleId/${articleId}`,
    );
  }

  loadByNumeroLot(numero: string): Observable<ArticleInfos[]> {
    const safeNumero = encodeURIComponent(numero); // très important: encodeURIComponent
    return this.httpClient.get<ArticleInfos[]>(
      `${environment.api()}/lots/article_infos/numero/${safeNumero}`,
    );
  }

  updateCurrentArticleInfos(articleId: string, ean13: string, ean14: string) {
    return this.httpClient.post<ArticleInfos>(
      `${environment.api()}/specification_etape/infosArticle/update`,
      { articleId, ean13, ean14 },
    );
  }
}
